import { IAccountComponentData } from "../../accounts/types/IAccountComponentData";
import { IUsageSearcResultConfiguration } from "../../repertoire/types/usageTypes/IUsageSearcResultConfiguration";
import { LoginType } from "../../accounts/types/LoginType";
import {
    ActionTypes,
    GetUsersRequest,
    GetUsersSuccess,
    GetUsersFailure,
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_FAILURE,
    LOGIN_REQUEST,
    LoginRequest,
    LOGIN_SUCCESS,
    LoginSuccess,
    LOGIN_FAILURE,
    LoginFailure,
    LogoutRequest,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LogoutSuccess,
    LOGOUT_FAILURE,
    LogoutFailure,
    AccountComponentDataRequest,
    FETCH_ACCOUNT_COMPONENT_DATA_REQUEST,
    AccountComponentDataSuccess,
    FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS,
    AccountComponentDataFailure,
    FETCH_ACCOUNT_COMPONENT_DATA_FAILURE,
    AppVersionNumberRequest,
    FETCH_APP_VERSION_NUMBER_REQUEST,
    FETCH_APP_VERSION_NUMBER_SUCCESS,
    FETCH_APP_VERSION_NUMBER_FAILURE,
    AppVersionNumberSuccess,
    AppVersionNumberFailure,
    LoginTypeRequest,
    LoginTypeSuccess,
    LoginTypeFailure,
    LOGIN_TYPE_REQUEST,
    LOGIN_TYPE_SUCCESS,
    LOGIN_TYPE_FAILURE,
    SAVE_ROLES,
    SaveRoles,
    SET_PORTAL_TYPE,
    SetPortalType,
    GET_CUSTOMER_SUCCESS,
    GetCustomerSuccess,
    GetUserCRMValuesSuccess,
    GET_USER_CRM_VALUES_SUCCESS,
    SetCurrentUserNameNumber,
    SET_CURRENT_USER_NAME_NUMBER,
    GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS,
    GetCustomerDateConfigurationSuccess,
    GetCustonerTimeZoneConfigurationSuccess,
    GetCustomerDefaultTerritoriesSuccess,
    GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS,
    GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS,
    GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS,
    GetUsageSearchResultConfigurationSuccess,
    SET_CLIENT,
    SetClient,
    GetMemberNumberConfigurationSuccess,
    GET_MEMBER_NUMBER_SUCCESS,
    GetRollUpTerritoriesConfigurationSuccess,
    GET_ROLL_UP_TERRITORIES_SUCCESS,
    GetEnabledAdjustmentICEWorkSearchRequest,
    GetEnabledAdjustmentICEWorkSearchSuccess,
    GetEnabledAdjustmentICEWorkSearchFailure,
    GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST,
    GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS,
    GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE,
    GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS,
    GetCatchUpAllocationsConfigurationSuccess,
    GetAllPackagesDetailsSuccess,
    GET_ALL_PACKAGES_DETAILS_SUCCESS,
    GET_ALL_PACKAGES_DETAILS_FAILURE,
    GetAllPackagesDetailsFailure,
    GET_IP_DETAILS_SUCCESS,
    GetIPDetailsSuccess,
    GetIPDetailsFailure,
    GET_IP_DETAILS_FAILURE,
    GetAllocationCustomerTerritoryConfigurationSuccess,
    GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS,
    GetCustomerContributorTypesConfigurationSuccess,
    GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS,
    GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS,
    GetCustomerNamesTypesConfigurationSuccess,
    GetCustomerIsUsageTabDefaultSetToMatchConfigurationSuccess,
    GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS,
    CLEAR_ACCOUNT_CONTEXT,
    ClearAccountContext,
    SET_ACCOUNT_SOCIETY_AFFILIATION,
    SetAccountSocietyAffiliation
} from "../actions/AccountActions";
import IAccountState from "../types/IAccountState";
import { IMyPackagesDetails } from "../../repertoire/types/IMyPackagesDetails";
import { IInterestedParty } from "../../repertoire/types/IInterestedParty";
import { PowerBIEmbed } from "powerbi-client-react";
import { AccountSessionStorage } from "../services/AccountSessionStorage";
import { IAccountSocietyAffiliation } from "../../membersportal/types/IAccountSocietyAffiliation";
import { IUserCRMValues } from "../../membersportal/types/IUserCRMValues";

const persistedActiveMemberContext = AccountSessionStorage.load();

const initialState: IAccountState = {
    users: [],
    currentUser: persistedActiveMemberContext.currentUser,
    loginFailed: false,
    enableCatchupAllocations: false,
    isSignedIn: false,
    componentData: {
        LoginPage: {
            fields: []
        }
    },
    appVersionNumber: null,
    loginType: undefined,
    roles: [],
    portalType: undefined,
    customer: undefined,
    customerDate: undefined,
    isUsageTabDefaultSetToMatch: false,
    currentUserNameNumber: persistedActiveMemberContext.currentUserNameNumber,
    currentUserIpBaseNumber: persistedActiveMemberContext.currentUserIpBaseNumber,
    currentUserAccountNumber: persistedActiveMemberContext.currentUserAccountNumber,
    currentViewAsUserName: persistedActiveMemberContext.currentViewAsUserName,
    defaultTerritories:undefined,
    customerTimeZone: undefined,
    usageSearchResultConfiguration : undefined,
    customerContributorTypes: undefined,
    customerNameTypes: undefined,
    enableMemberNumber: false,
    enableRollUpTerritories: false,
    enableAdjustmentICEWorkSearch: false,
    currentUserGuid: persistedActiveMemberContext.currentUserGuid,
    accountSocietyAffiliation: undefined,
}

export function getUsersRequest(): GetUsersRequest {
    return {
        type: GET_USERS_REQUEST
    };
}

export function getUsersSuccess(users: string[]): GetUsersSuccess {
    return {
        type: GET_USERS_SUCCESS,
        payload: {
            users
        }
    };
}

export function getUsersFailure(error: string): GetUsersFailure {
    return {
        type: GET_USERS_FAILURE,
        payload: { error }
    };
}

export function loginRequest(): LoginRequest {
    return {
        type: LOGIN_REQUEST
    };
}

export function loginSuccess(username: string, currentUserNameNumber: string): LoginSuccess {
    return {
        type: LOGIN_SUCCESS,
        payload: {
            username,
            currentUserNameNumber
        }
    };
}

export function loginFailure(error: string): LoginFailure {
    return {
        type: LOGIN_FAILURE,
        payload: { error }
    };
}

export function logoutRequest(): LogoutRequest {
    return {
        type: LOGOUT_REQUEST
    };
}

export function logoutSuccess(): LogoutSuccess {
    return {
        type: LOGOUT_SUCCESS
    };
}

export function logoutFailure(error: string): LogoutFailure {
    return {
        type: LOGOUT_FAILURE,
        payload: { error }
    };
}

export function getAccountComponentDataRequest(): AccountComponentDataRequest {
    return {
        type: FETCH_ACCOUNT_COMPONENT_DATA_REQUEST
    };
}

export function getAccountComponentDataSuccess(componentData: IAccountComponentData): AccountComponentDataSuccess {
    return {
        type: FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS,
        payload: {
            componentData
        }
    };
}

export function getAccountComponentDataFailure(error: string): AccountComponentDataFailure {
    return {
        type: FETCH_ACCOUNT_COMPONENT_DATA_FAILURE,
        payload: { error }
    };
}

export function getAppVersionNumberRequest(): AppVersionNumberRequest {
    return {
        type: FETCH_APP_VERSION_NUMBER_REQUEST
    };
}

export function getAppVersionNumberSuccess(appVersionNumber: string): AppVersionNumberSuccess {
    return {
        type: FETCH_APP_VERSION_NUMBER_SUCCESS,
        payload: {
            appVersionNumber
        }
    };
}

export function getAppVersionNumberFailure(error: string): AppVersionNumberFailure {
    return {
        type: FETCH_APP_VERSION_NUMBER_FAILURE,
        payload: { error }
    };
}

export function loginTypeRequest(): LoginTypeRequest {
    return {
        type: LOGIN_TYPE_REQUEST
    };
}

export function loginTypeSuccess(loginType: string): LoginTypeSuccess {
    return {
        type: LOGIN_TYPE_SUCCESS,
        payload: {
            loginType
        }
    };
}

export function loginTypeFailure(error: string): LoginTypeFailure {
    return {
        type: LOGIN_TYPE_FAILURE,
        payload: { error }
    };
}

export function saveRoles(roles: string[]): SaveRoles {
    return {
        type: SAVE_ROLES,
        payload: { roles }
    };
}

export function setPortalType(portalType: string): SetPortalType {
    return {
        type: SET_PORTAL_TYPE,
        payload: { portalType }
    }
}

export function setClient(client: string): SetClient {
    return {
        type: SET_CLIENT,
        payload: { client }
    }
}


export function getCustomerSuccess(customer: string): GetCustomerSuccess {
    return {
        type: GET_CUSTOMER_SUCCESS,
        payload: { customer }
    }
}

export function getCustomerDefaultTerritoriesSuccess(defaultTerritories: any): GetCustomerDefaultTerritoriesSuccess {
    return {
        type: GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS,
        payload: { defaultTerritories }
    }
}

export function getCustomerNamesTypesConfigurationSuccess(customerNameTypes: string[]): GetCustomerNamesTypesConfigurationSuccess {
    return {
        type: GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS,
        payload: { customerNameTypes }
    }
}

export function getCustomerContributorTypesConfigurationSuccess(contributorTypes: string[]): GetCustomerContributorTypesConfigurationSuccess {
    return {
        type: GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS,
        payload: { contributorTypes }
    }
}
export function getCustomerDateConfigurationSuccess(customerDate: string): GetCustomerDateConfigurationSuccess {
    return {
        type: GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS,
        payload: { customerDate }
    }
}

export function getCustomerIsUsageTabDefaultSetToMatchConfigurationSuccess(isUsageTabDefaultSetToMatch: boolean): GetCustomerIsUsageTabDefaultSetToMatchConfigurationSuccess {
    return {
        type: GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS,
        payload: { isUsageTabDefaultSetToMatch }
    }
}

export function getCatchUpAllocationsConfigurationSuccess(enableCatchupAllocations: boolean): GetCatchUpAllocationsConfigurationSuccess {
    return {
        type: GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS,
        payload: { enableCatchupAllocations }
    }
}

export function getCustonerTimeZoneConfigurationSuccess(customerTimeZone: string): GetCustonerTimeZoneConfigurationSuccess {
    return {
        type: GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS,
        payload: { customerTimeZone }
    }
}
export function getAllocationCustomerTerritoryConfigurationSuccess(allocationCustomerTerritory: string): GetAllocationCustomerTerritoryConfigurationSuccess {
    return {
        type: GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS,
        payload: { allocationCustomerTerritory }
    }
}

export function getMemberNumberConfigurationSuccess(enableMemberNumber: boolean): GetMemberNumberConfigurationSuccess {
    return {
        type: GET_MEMBER_NUMBER_SUCCESS,
        payload: { enableMemberNumber }
    }
}

export function getRollUpTerritoriesConfigurationSuccess(enableRollUpTerritories: boolean): GetRollUpTerritoriesConfigurationSuccess {
    return {
        type: GET_ROLL_UP_TERRITORIES_SUCCESS,
        payload: { enableRollUpTerritories }
    }
}

export function getAllPackagesDetailsSuccess(result: IMyPackagesDetails[]): GetAllPackagesDetailsSuccess {
    return {
        type: GET_ALL_PACKAGES_DETAILS_SUCCESS,
        payload: {
            myPackagesDetails: result
        }
    };
}

export function getIPDetailsSuccess(result: IInterestedParty): GetIPDetailsSuccess {
    return {
        type: GET_IP_DETAILS_SUCCESS,
        payload: {
            ipDetails: result
        }
    }
}

export function getIPDetailsFailure(error: string, ipBaseNumber?: string, accountNumber?: string): GetIPDetailsFailure {
    return {
        type: GET_IP_DETAILS_FAILURE,
        payload: {
            error,
            ipBaseNumber,
            accountNumber
        }
    };
}
export function getAllPackagesDetailsFailure(error: string, userName: string): GetAllPackagesDetailsFailure {
    return {
        type: GET_ALL_PACKAGES_DETAILS_FAILURE,
        payload: {
            error,
            userName
        }
    };
}


export function getUserCRMValuesSuccess(userCRMValues: IUserCRMValues): GetUserCRMValuesSuccess {
    return {
        type: GET_USER_CRM_VALUES_SUCCESS,
        payload: {
            userCRMValues
        }
    }
}


export function setCurrentUserNameNumber(userCRMValues: IUserCRMValues): SetCurrentUserNameNumber {
    return {
        type: SET_CURRENT_USER_NAME_NUMBER,
        payload: { userCRMValues }
    }
}

export function getUsageSearchResultConfigurationSuccess(customerUsageSearchResult: IUsageSearcResultConfiguration): GetUsageSearchResultConfigurationSuccess {
    return {
        type: GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS,
        payload: { customerUsageSearchResult }
    }
}

export function getEnabledAdjustmentICEWorkSearchRequest (): GetEnabledAdjustmentICEWorkSearchRequest {
    return {
        type: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST
    };
}

export function getEnabledAdjustmentICEWorkSearchSuccess (enableAdjustmentICEWorkSearch: boolean): GetEnabledAdjustmentICEWorkSearchSuccess  {
    return {
        type: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS,
        payload: { enableAdjustmentICEWorkSearch }
    }
}

export function getEnabledAdjustmentICEWorkSearchFailure (error: string): GetEnabledAdjustmentICEWorkSearchFailure  {
    return {
        type: GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE,
        payload: { error }
    };
}

export function clearAccountContext(): ClearAccountContext {
    return {
        type: CLEAR_ACCOUNT_CONTEXT
     };
}  

export function setAccountSocietyAffiliation(accountSocietyAffiliation: IAccountSocietyAffiliation): SetAccountSocietyAffiliation {
    return {
        type: SET_ACCOUNT_SOCIETY_AFFILIATION,
        payload: {
            accountSocietyAffiliation
        }
    };
}

const accountReducer = (
    state: IAccountState | undefined,
    action: ActionTypes
): IAccountState => {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case GET_USERS_SUCCESS: {
            const { users } = action.payload;
            return {
                ...state,
                users
            }
        }
        case LOGIN_SUCCESS: {
            const { username, currentUserNameNumber } = action.payload;
            return {
                ...state,
                currentUser: username,
                loginFailed: false,
                isSignedIn: true,
                currentUserNameNumber,
                
            }
        }
        case LOGIN_FAILURE: {
            return {
                ...state,
                loginFailed: true,
                isSignedIn: false
            }
        }
        case LOGOUT_SUCCESS: {
            return {
                ...state,
                currentUser: '',
                loginFailed: false,
                isSignedIn: false,
                currentUserNameNumber: undefined,
                currentViewAsUserName: undefined,
                currentUserGuid: undefined,
                myPackagesDetails: undefined,
                ipDetails: undefined
            }
        }
        case FETCH_ACCOUNT_COMPONENT_DATA_SUCCESS: {
            const { componentData } = action.payload;
            return {
                ...state,
                componentData
            };
        }
        case FETCH_APP_VERSION_NUMBER_SUCCESS: {
            const { appVersionNumber } = action.payload;
            return {
                ...state,
                appVersionNumber
            };
        }
        case LOGIN_TYPE_SUCCESS: {
            const { loginType } = action.payload;
            return {
                ...state,
                loginType: LoginType[loginType]
            }
        }
        case SAVE_ROLES: {
            const { roles } = action.payload;

            return {
                ...state,
                roles
            }
        }
        case SET_PORTAL_TYPE: {
            const { portalType } = action.payload
            return {
                ...state,
                portalType
            }
        }
        case SET_CLIENT: {
            const { client } = action.payload
            return {
                ...state,
                client
            }
        }
        case GET_CUSTOMER_SUCCESS: {
            const { customer } = action.payload;
            return {
                ...state,
                customer
            }
        }
        case GET_CUSTOMER_DEFAULT_TERRITORIES_SUCCESS: {
            const { defaultTerritories } = action.payload;
            return {
                ...state,
                defaultTerritories
            }
        }
        case GET_CUSTOMER_DATE_CONFIGURATION_SUCCESS: {
            const { customerDate } = action.payload;
            return {
                ...state,
                customerDate
            }
        }
        case GET_CUSTOMER_IS_USAGE_TAB_DEFAULT_SET_TO_MATCH_CONFIGURATION_SUCCESS: {
            const { isUsageTabDefaultSetToMatch } = action.payload;
            return {
                ...state,
                isUsageTabDefaultSetToMatch
            }
        }
        case GET_CUSTOMER_CONTRIBUTOR_TYPES_CONFIGURATION_SUCCESS: {
            const { contributorTypes } = action.payload;
            return {
                ...state,
                customerContributorTypes: contributorTypes
            }
        }
        case GET_CUSTOMER_NAMES_TYPES_CONFIGURATION_SUCCESS: {
            const { customerNameTypes } = action.payload;
            return {
                ...state,
                customerNameTypes
            }
        }
        case GET_CATCHUP_ALLOCATIONS_CONFIGURATION_SUCCESS: {
            const { enableCatchupAllocations } = action.payload;
            return {
                ...state,
                enableCatchupAllocations
            }
        }
        case GET_CUSTOMER_TIME_ZONE_CONFIGURATION_SUCCESS: {
            const { customerTimeZone } = action.payload;
            return {
                ...state,
                customerTimeZone
            }
        }
        case GET_ALLOCATION_CUSTOMER_TERRITORY_CONFIGURATION_SUCCESS:{
            const { allocationCustomerTerritory } = action.payload;
            return {
                ...state,
                allocationCustomerTerritory
            }
        }
        case GET_USER_CRM_VALUES_SUCCESS: {
            return {
                ...state,
                currentUserNameNumber: action.payload.userCRMValues.ipNameNumber,
                currentUserIpBaseNumber: action.payload.userCRMValues.ipBaseNumber,
                currentUserAccountNumber: action.payload.userCRMValues.accountNumber,
                currentUserGuid: action.payload.userCRMValues.guid
            }
        }
        case SET_CURRENT_USER_NAME_NUMBER:{
            return {
                ...state,
                currentUserNameNumber: action.payload.userCRMValues.ipNameNumber,
                currentUserIpBaseNumber: action.payload.userCRMValues.ipBaseNumber,
                currentUserAccountNumber: action.payload.userCRMValues.accountNumber,
                currentViewAsUserName: action.payload.userCRMValues.userName,
                currentUserGuid: action.payload.userCRMValues.guid
            }
        }
        case GET_MEMBER_NUMBER_SUCCESS: {
            const { enableMemberNumber } = action.payload;
            return {
                ...state,
                enableMemberNumber
            }
        }  
        case GET_ROLL_UP_TERRITORIES_SUCCESS: {
            const { enableRollUpTerritories } = action.payload;
            return {
                ...state,
                enableRollUpTerritories
            }
        }  
        case GET_ALL_PACKAGES_DETAILS_SUCCESS: {
                const { myPackagesDetails } = action.payload;
                return {
                    ...state,
                    myPackagesDetails
                };
            }
        case GET_IP_DETAILS_SUCCESS: {
            const { ipDetails } = action.payload;
            return {
                ...state,
                ipDetails: ipDetails
            }
        }
        case GET_USAGE_SEARCH_CONFIGURATION_SUCCESSS: {
            return {
                ...state,
                usageSearchResultConfiguration: action.payload.customerUsageSearchResult
            }
        }
        case GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_REQUEST: {
            return {
                ...state,
            }
        }
        case GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_SUCCESS: {
            const { enableAdjustmentICEWorkSearch  } = action.payload;
            return {
                ...state,
                enableAdjustmentICEWorkSearch 
            }
        }
        case GET_ENABLED_ADJUSTMENT_ICE_WORK_SEARCH_FAILURE: {
            return {
                ...state,
            }
        }
        case CLEAR_ACCOUNT_CONTEXT: {
            return {
                ...state,
                currentUserNameNumber: undefined,
                currentViewAsUserName: undefined,
                currentUserGuid: undefined,
                myPackagesDetails: undefined,
                ipDetails: undefined
            };
        }
        case SET_ACCOUNT_SOCIETY_AFFILIATION: {
            return {
                ...state,
                accountSocietyAffiliation: action.payload.accountSocietyAffiliation
            };
        }
        default:
            return state;
    }
}

export default accountReducer;